<!-- ============================================================
     TELEPHONE DIRECTORY
     ============================================================ -->
<div class="dir-page">

  <!-- ── TOAST ─────────────────────────────────────────────── -->
  @if (toast()) {
    <div class="dir-toast alert d-flex align-items-center gap-2 shadow"
         [class.alert-success]="!toast().includes('failed')"
         [class.alert-danger]="toast().includes('failed')">
      <i class="bi {{ toast().includes('Copied') ? 'bi-clipboard-check-fill' : 'bi-check-circle-fill' }} fs-5"></i>
      <strong>{{ toast() }}</strong>
    </div>
  }

  <!-- ══════════════════════════════════════════════════════
       ADD / EDIT CONTACT MODAL
       ══════════════════════════════════════════════════════ -->
  @if (showModal()) {
    <!-- <div class="dir-overlay" (click)="showModal.set(false)"> -->
    <div class="dir-overlay">
      <div class="dir-modal" (click)="$event.stopPropagation()">
        <div class="dmh py-2">
          <div><h5 class="dmh-title">{{ editingId() ? 'Edit Contact' : 'Add New Contact' }}</h5></div>
          <button class="dmh-close" (click)="showModal.set(false)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="dmb p-4">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label fw-semibold">Full Name <span class="req">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="contactForm.name" maxlength="100" placeholder="Dr. / Mr. / Mrs. …" [class.is-invalid]="formSubmitted && !contactForm.name?.trim()">
              @if (formSubmitted && !contactForm.name?.trim()) { <div class="invalid-feedback">Name is required.</div> }
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Designation / Role</label>
              <!-- <input type="text" class="form-control" [(ngModel)]="contactForm.designation" maxlength="100" placeholder="e.g. Principal, HOD – Science"> -->
              <select class="form-select" id="designation" name="designation" [(ngModel)]="contactForm.designation">
                <option value="">Select</option>
                @for(desi of dataService.designations; track $index;) {
                <option value="{{desi.code}}">{{desi.name}}</option>
                }
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Department</label>
              <!-- <input type="text" class="form-control" [(ngModel)]="contactForm.department" maxlength="80" list="dept-list" placeholder="e.g. Science Dept">
              <datalist id="dept-list">
                @for (d of uniqueDepts(); track d) { <option [value]="d"> }
              </datalist> -->
              <select class="form-select" [(ngModel)]="contactForm.department">
                <option value="">Select Department</option>
                @for(d of dataService.departments; track $index) {
                  <option value="{{d.code}}">{{d.name}}</option>
                }
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Contact Type</label>
              <select class="form-select" [(ngModel)]="contactForm.contact_type">
                @for (t of contactTypes; track t) { <option [value]="t">{{ t }}</option> }
              </select>
            </div>
            <!-- Phone Numbers -->
            <!-- <div class="col-12"><div class="section-divider"><span>Phone Numbers</span></div></div> -->
            <div class="col-md-4">
              <label class="form-label fw-semibold">Primary Mobile <span class="req">*</span></label>
              <div class="input-group">
                <span class="input-group-text bg-light"><i class="bi bi-telephone-fill text-success"></i></span>
                <input type="tel" class="form-control" [(ngModel)]="contactForm.phone_primary" maxlength="20" placeholder="9876543210" [class.is-invalid]="formSubmitted && !contactForm.phone_primary?.trim()">
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Secondary Mobile</label>
              <div class="input-group">
                <span class="input-group-text bg-light"><i class="bi bi-telephone text-muted"></i></span>
                <input type="tel" class="form-control" [(ngModel)]="contactForm.phone_secondary" maxlength="20" placeholder="Optional">
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Office / Landline</label>
              <div class="input-group">
                <span class="input-group-text bg-light"><i class="bi bi-building text-muted"></i></span>
                <input type="tel" class="form-control" [(ngModel)]="contactForm.phone_office" maxlength="20" placeholder="022-XXXXXXXX">
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Extension</label>
              <div class="input-group">
                <span class="input-group-text bg-light small fw-bold text-muted">Ext.</span>
                <input type="text" class="form-control" [(ngModel)]="contactForm.extension" maxlength="10" placeholder="101">
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">WhatsApp Number</label>
              <div class="input-group">
                <span class="input-group-text" style="background:#25d366;border-color:#25d366;"><i class="bi bi-whatsapp text-white"></i></span>
                <input type="tel" class="form-control" [(ngModel)]="contactForm.whatsapp" maxlength="15" placeholder="If different from primary">
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Email</label>
              <div class="input-group">
                <span class="input-group-text bg-light"><i class="bi bi-envelope-fill text-muted"></i></span>
                <input type="email" class="form-control" [(ngModel)]="contactForm.email" maxlength="100" placeholder="name@school.in">
              </div>
            </div>
            <!-- Extra -->
            <!-- <div class="col-12"><div class="section-divider"><span>Settings</span></div></div> -->
            <div class="col-12">
              <label class="form-label fw-semibold">Notes</label>
              <input type="text" class="form-control" [(ngModel)]="contactForm.notes" maxlength="200" placeholder="Additional notes…">
            </div>
          </div>
          @if (hasFormErrors()) {
            <div class="alert alert-danger d-flex gap-2 align-items-center py-2"
              style="position: absolute; margin-top: 35px;">
              <i class="bi bi-exclamation-triangle-fill"></i> Name and primary mobile are required.
            </div>
          }
        </div>
        <div class="dmf d-flex align-items-center justify-content-between">
          <div class="col-md-6">
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" role="switch" [(ngModel)]="contactForm.is_favorite" id="chk-fav">
              <label class="form-check-label" for="chk-fav"><i class="bi bi-star-fill text-warning me-1"></i>Mark as Favourite</label>
            </div>
          </div>
          <div class="col-md-6 d-flex gap-3 align-items-center justify-content-end me-2">
            <button class="btn btn-outline-secondary px-3" (click)="showModal.set(false)">Cancel</button>
            <button class="btn dir-btn-primary px-3" (click)="saveContact()">
              <i class="bi bi-check-circle-fill me-1"></i>{{ editingId() ? 'Update Contact' : 'Add Contact' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- ════════════════════════════════════════════════════════
       PAGE HEADER & SEARCH
       ════════════════════════════════════════════════════════ -->
  <div class="dir-ph mb-4">
    <div class="dph-left">
      <div class="dir-logo"><i class="bi bi-telephone-fill"></i></div>
      <div>
        <h1 class="dir-title">Telephone Directory</h1>
        <p class="dir-subtitle">School & College contact book — staff, emergency, vendors, departments</p>
      </div>
    </div>

    <!-- TABS -->
    <div class="col-6 dir-tabs mb-4">
      <!-- @for (t of [{k:'directory',l:'Directory',ic:'bi-person-lines-fill'},{k:'groups',l:'By Type',ic:'bi-collection-fill'},{k:'emergency',l:'Emergency',ic:'bi-exclamation-octagon-fill'},{k:'manage',l:'Manage',ic:'bi-gear-fill'}]; track t.k) { -->
      @for (t of [{k:'emergency',l:'Emergency',ic:'bi-exclamation-octagon-fill'},{k:'manage',l:'Manage',ic:'bi-gear-fill'}]; track t.k) {
        <button class="dtab" [class.active]="activeTab() === t.k" (click)="activeTab.set($any(t.k))">
          <i class="bi {{ t.ic }} me-1"></i>{{ t.l }}
        </button>
      }
    </div>
  </div>

  <!-- ════════════════════════════════════════════════════════
       EMERGENCY TAB
       ════════════════════════════════════════════════════════ -->
  @if (activeTab() === 'emergency') {
    <div class="emg-banner mb-4">
      <i class="bi bi-exclamation-octagon-fill emg-banner-icon"></i>
      <div>
        <div class="emg-banner-title">Emergency Quick Dial</div>
        <div class="emg-banner-sub">Tap to call instantly. Keep this page accessible during any emergency.</div>
      </div>
    </div>

    <!-- National Helplines -->
    <div class="emg-section-hdr mb-2"><i class="bi bi-shield-fill me-2"></i>National Emergency Helplines</div>
    <div class="emg-quick-row mb-4">
      @for (e of [{ num:'100', label:'Police', icon:'bi-shield-fill', color:'#1d4ed8' }, { num:'101', label:'Fire Brigade', icon:'bi-fire', color:'#dc2626' }, { num:'102', label:'Ambulance', icon:'bi-hospital-fill', color:'#059669' }, { num:'112', label:'All Emergencies', icon:'bi-telephone-fill', color:'#7c3aed' }]; track e.num) {
        <a [href]="getCallLink(e.num)" class="emg-quick-card" [style.border-color]="e.color">
          <div class="eqc-icon" [style.background]="e.color"><i class="bi {{ e.icon }}"></i></div>
          <div class="eqc-num" [style.color]="e.color">{{ e.num }}</div>
          <div class="eqc-label">{{ e.label }}</div>
          <div class="eqc-call"><i class="bi bi-telephone-fill me-1"></i>TAP TO CALL</div>
        </a>
      }
    </div>

    <!-- All emergency contacts from directory -->
    <div class="emg-section-hdr mb-3"><i class="bi bi-telephone-fill me-2"></i>School Emergency Contacts</div>
    <div class="emg-list">
      @for (e of emergencyContacts(); track e.id) {
        <div class="emg-card">
          <div class="emg-av"><i class="bi bi-telephone-fill"></i></div>
          <div class="emg-info">
            <div class="emg-name">{{ e.name }}</div>
            <div class="emg-desig">{{ e.designation }}</div>
          </div>
          <div class="emg-nums">
            <div class="emg-phone {{ isEmergencyShort(e.phone_primary) ? 'emg-short-num' : '' }}">{{ e.phone_primary }}</div>
            @if (e.phone_secondary) { <div class="emg-phone2">Alt: {{ e.phone_secondary }}</div> }
          </div>
          <div class="emg-btns">
            <a [href]="getCallLink(e.phone_primary)" class="emg-call-btn">
              <i class="bi bi-telephone-fill me-1"></i>CALL
            </a>
            <button class="emg-copy-btn" (click)="copyPhone(e.phone_primary)">
              <i class="bi {{ copied() === e.phone_primary ? 'bi-clipboard-check-fill' : 'bi-clipboard-fill' }}"></i>
            </button>
          </div>
        </div>
      }
    </div>

    <!-- Other important numbers from School directory -->
    <div class="emg-section-hdr mt-4 mb-3"><i class="bi bi-heart-pulse-fill me-2"></i>School First Aid & Security</div>
    <div class="emg-list">
      @for (c of contacts(); track c.id) {
        @if (c.is_active && c.is_favorite && c.contact_type !== 'Emergency') {
          <div class="emg-card emg-card-fav">
            <div class="emg-av" [style.background]="getTypeColor(c.contact_type)">{{ getInitials(c.name) }}</div>
            <div class="emg-info">
              <div class="emg-name">{{ c.name }}</div>
              <div class="emg-desig">{{ c.designation }}{{ c.designation && c.department ? ' · ' : '' }}{{ c.department }}</div>
            </div>
            <div class="emg-nums">
              <div class="emg-phone small-phone">{{ c.phone_primary }}</div>
              @if (c.extension) { <div class="emg-phone2">Ext. {{ c.extension }}</div> }
            </div>
            <div class="emg-btns">
              <a [href]="getCallLink(c.phone_primary)" class="emg-call-btn emg-call-alt">
                <i class="bi bi-telephone-fill me-1"></i>CALL
              </a>
            </div>
          </div>
        }
      }
    </div>
  }

  <!-- ════════════════════════════════════════════════════════
       MANAGE TAB
       ════════════════════════════════════════════════════════ -->
  @if (activeTab() === 'manage') {
    <div class="dir-card-outer mb-3">
      <div class="px-3 py-2 d-flex gap-3 align-items-center flex-wrap">
        <div class="input-group" style="max-width:380px;">
          <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
          <input class="form-control border-start-0" placeholder="Search name, phone, department…"
            [value]="manageSearch()" (input)="manageSearch.set($any($event.target).value)">
          @if (manageSearch()) { <button class="btn btn-outline-secondary" (click)="manageSearch.set('')"><i class="bi bi-x"></i></button> }
        </div>
        <span class="text-muted small">#{{ manageList().length }} contact(s)</span>
        <button class="btn dir-btn-primary btn-sm ms-auto" (click)="openForm()"><i class="bi bi-person-plus-fill me-1"></i>Add Contact</button>
      </div>
    </div>

    <div class="dir-card-outer">
      <div class="table-responsive">
        <table class="dir-table">
          <thead><tr>
            <th>Name</th><th>Designation</th><th>Department</th><th>Type</th>
            <th>Primary Phone</th><th>Extension</th><th>Email</th>
            <th class="text-center">Fav</th><th class="text-center">Status</th><th>Actions</th>
          </tr></thead>
          <tbody>
            @for (c of manageList(); track c.id) {
              <tr [class.row-inactive]="!c.is_active">
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <div class="tiny-av" [style.background]="c.is_active ? getTypeColor(c.contact_type) : '#d1d5db'">{{ getInitials(c.name) }}</div>
                    <span class="small fw-semibold {{ !c.is_active ? 'text-muted' : '' }}">{{ c.name }}</span>
                  </div>
                </td>
                <td class="small text-muted">{{ c.designation || '—' }}</td>
                <td class="small">{{ c.department || '—' }}</td>
                <td>
                  <span class="type-chip-sm" [style.background]="getTypeBg(c.contact_type)" [style.color]="getTypeColor(c.contact_type)">{{ c.contact_type }}</span>
                </td>
                <td class="small fw-semibold font-mono">{{ c.phone_primary }}</td>
                <td class="small text-muted text-center">{{ c.extension || '—' }}</td>
                <td class="small text-muted">{{ c.email || '—' }}</td>
                <td class="text-center">
                  <button class="fav-btn-sm {{ c.is_favorite ? 'starred' : '' }}" (click)="toggleFavorite(c.id)">
                    <i class="bi bi-star-fill"></i>
                  </button>
                </td>
                <td class="text-center">
                  <span class="{{ c.is_active ? 'st-active' : 'st-inactive' }}">{{ c.is_active ? 'Active' : 'Inactive' }}</span>
                </td>
                <td>
                  <div class="d-flex gap-1">
                    <a [href]="getCallLink(c.phone_primary)" class="act-btn call" title="Call"><i class="bi bi-telephone-fill"></i></a>
                    <button class="act-btn copy" (click)="copyPhone(c.phone_primary)" title="Copy"><i class="bi bi-clipboard-fill"></i></button>
                    <button class="act-btn edit" (click)="openForm(c)" title="Edit"><i class="bi bi-pencil-fill"></i></button>
                    <button class="act-btn {{ c.is_active ? 'deact' : 'react' }}" (click)="toggleActive(c.id)" [title]="c.is_active ? 'Deactivate' : 'Reactivate'">
                      <i class="bi {{ c.is_active ? 'bi-person-dash-fill' : 'bi-person-check-fill' }}"></i>
                    </button>
                    <button class="act-btn del" (click)="deleteContact(c.id)" title="Delete"><i class="bi bi-trash3-fill"></i></button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

</div>
